import React from 'react';
import './style.scss';

function underConstruction() {
  return (
    <div className="construction-container">
      <img src="/content/images/under-construction.png" alt="en cours de construction"></img>

      <h1 className="text-bold">Page en cours de construction </h1>
    </div>
  );
}

export default underConstruction;
